import React from 'react'
import BaseTooth from './BaseTooth'
import { ToothComponentProps } from './types/tooth.types'

/** Factory for palatal-view tooth components (upper teeth 1–16). */
export const createToothPalatal = (
  toothNumber: number,
): React.FC<ToothComponentProps> => {
  const ToothComponent = (props: ToothComponentProps): React.ReactElement => {
    return <BaseTooth toothNumber={toothNumber} view="palatal" {...props} />
  }
  ToothComponent.displayName = `ToothPalatal${toothNumber}`
  return ToothComponent
}
